const useQuery = (search: any) => new URLSearchParams(search);

export const GetURLQuery = (search: string, name: string) => useQuery(search).get(name);
